import React, {useContext, useEffect} from "react"
import Image from "next/image"
import {appLinks} from "@/lib/links"
import {usePathname} from "next/navigation"
import { GLOBAL_PATHS } from "@/lib/globals"
import useScreenSize from "@/hooks/navigator/useScreenSize"
import { TypeAnimation } from "react-type-animation"
import { TranslationContext } from "@/configs/context"
import { Box, Stack, Typography, useMediaQuery, useTheme } from "@mui/material"


export default function LoadingWrapper ({ error, mini, customImage } : { error?: boolean | string, mini?: boolean, customImage?: string }) {
  const theme = useTheme()
  const pathname = usePathname()
  const screenSize = useScreenSize()
  // @ts-expect-error:next-line
  const { t }: object = useContext(TranslationContext)
  const matchMd = useMediaQuery(theme.breakpoints.up('md'))

  const chatRegExp = React.useMemo(
    () => new RegExp(appLinks.account.CHAT, 'gi'),
    []
  )
  const isChatUI = React.useMemo(() => chatRegExp.test(pathname), [chatRegExp, pathname])

  let imageSize = 10 * 16
  let imagePlaceholder = `${GLOBAL_PATHS.GLASS}8715071.webp`

  if (error) {
    imageSize = 14 * 16
    imagePlaceholder = `${GLOBAL_PATHS.IMAGES}8538919.webp`
  }
  if (customImage) {
    imageSize = 14 * 16
    imagePlaceholder = customImage
  }
  if (mini) { imageSize = 4 * 16 }

  // useEffect(() => {
  //   const htmlElement = document.documentElement

  //   if (!isChatUI && htmlElement?.classList.contains('splashscreen')) {
  //     htmlElement.classList.remove('splashscreen')
  //   }
  // }, [isChatUI])

  return (
    <Stack
      spacing={2}
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={{ height: screenSize.height/1.5 }}
    >
      <Box>
        <Image
          alt=""
          priority={true}
          loading="eager"
          width={imageSize}
          height={imageSize}
          src={imagePlaceholder}
        />
      </Box>
      <Typography
        align="center"
        component="div"
        variant={error ? matchMd ? "h6" : "body1" : "body1"}
        sx={{
          mt: `${error ?  "1" : "-.5"}rem !important`,
          maxWidth: matchMd ? screenSize.width/2 : "default"
       }}
      >
        {error ??
          <TypeAnimation
          speed={90}
          cursor={true}
          wrapper="span"
          repeat={Infinity}
          sequence={[
            () => { },
            t('translation:vcard.loading'),
            1500,
            t('translation:vcard.wait_please'),
            1500,
          ]}
        />}
      </Typography>
    </Stack>
  )
}